import { useEffect, useRef } from "react";
import { ScrollArea, ScrollBar } from "@/components/ui/scroll-area";

export default function CategoryFilter({ categories, activeCategory, onSelectCategory }) {
  const buttonRefs = useRef({});

  // Auto-scroll filter bar to keep active category button in view
  useEffect(() => {
    if (!activeCategory) return;
    const btn = buttonRefs.current[activeCategory];
    if (btn) {
      btn.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
    }
  }, [activeCategory]);

  return (
    <div className="bg-white border-b sticky top-[60px] z-30">
      <ScrollArea className="max-w-7xl mx-auto">
        <div className="flex gap-2 p-3 px-4">
          {categories.map((category) => {
            const isActive = activeCategory === category.key;
            return (
              <button
                key={category.key}
                ref={(el) => { buttonRefs.current[category.key] = el; }}
                onClick={() => onSelectCategory(category.key)}
                className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all flex items-center gap-1.5 flex-shrink-0 ${
                  isActive
                    ? "text-white shadow-md"
                    : "bg-gray-100 text-gray-700 hover:bg-gray-200 border border-gray-200"
                }`}
                style={{
                  backgroundColor: isActive ? category.color : undefined,
                  borderColor: isActive ? category.color : undefined,
                }}
                data-testid={`category-${category.key}`}
              >
                {category.image_base64 ? (
                  <img
                    src={category.image_base64}
                    alt=""
                    className="w-5 h-5 rounded-full object-cover flex-shrink-0"
                    loading="lazy"
                  />
                ) : (
                  <span className="text-base flex-shrink-0">🍽️</span>
                )}
                <span>{category.label}</span>
              </button>
            );
          })}
        </div>
        <ScrollBar orientation="horizontal" />
      </ScrollArea>
    </div>
  );
}
